<div [formGroup]="formGroup" *ngIf="formReady" class="data-rollover-settings">
    <div *ngIf="dataRolloverSettings?.length === 0 && !hasDataRolloverSettingsLoadError"
         class="default-message"
    >
        <p>
            No data rollover settings to display.
        </p>
    </div>

    <h3 *ngIf="isSystemSettings" class="title">
        <button mat-icon-button
                class="arrow-back"
                title="Go back"
                (click)="onCancelEdit()"
                type="button"
        >
            <mat-icon aria-hidden="true">arrow_back</mat-icon>
        </button>
        Edit {{orgName}} data rollover settings
    </h3>

    <ng-container *ngFor="let item of dataRolloverSettings; let i = index">
        <div [formGroupName]="item.settingsType"
             class="configuration-group-container"
             [ngClass]="{'several-group': dataRolloverSettings?.length > 1}"
        >
            <ng-container *ngIf="(dataRolloverSettings?.length > 0)">
                <div *ngIf="dataRolloverSettings?.length > 1"
                     class="group-header"
                >
                    <mat-checkbox *ngIf="!isSystemSettings && !isPreviewDialog"
                                  formControlName="isEnabled"
                                  [checked]="item.isEnabled"
                                  (change)="selectGroup(item, $event.checked)"
                    >
                        <ng-container *ngTemplateOutlet="dataRolloverSettingTitle; context:{item: item}"></ng-container>
                    </mat-checkbox>

                    <ng-container *ngIf="isSystemSettings || isPreviewDialog">
                        <ng-container *ngTemplateOutlet="dataRolloverSettingTitle; context:{item: item}"></ng-container>
                    </ng-container>
                </div>
            </ng-container>

            <div class="configuration-group-content" [ngStyle]="{'min-height': isPreviewDialog ? '112px' : 'auto' }">
                <div class="input-name"
                     fxLayout="row" fxLayoutAlign="flex-start center"
                     [ngStyle]="{'padding': isPreviewDialog ? '0 8px 8px 8px' : '8px 0 8px 36px' }"
                >
                    <mat-form-field>
                        <input matInput
                               formControlName="startDate"
                               autocomplete="off"
                               [placeholder]="'Start date'"
                               [matDatepickerFilter]="datePickerFilters[item.settingsType]"
                               [matDatepicker]="startDatePicker"
                               (click)="startDatePicker.open()"
                               (dateChange)="changeDateOrDuration(i)"
                               [required]="isFormFieldRequired(item.settingsType)"
                        >
                        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #startDatePicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field class="ml-32">
                        <input matInput
                               formControlName="endDate"
                               autocomplete="off"
                               [placeholder]="'End date'"
                               [matDatepickerFilter]="datePickerFilters[item.settingsType]"
                               [matDatepicker]="endDatePicker"
                               (click)="endDatePicker.open()"
                               (dateChange)="changeDateOrDuration(i)"
                               [required]="isFormFieldRequired(item.settingsType)"
                        >
                        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #endDatePicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field class="ml-32" *ngIf="isPreviewDialog">
                        <mat-label>Days duration</mat-label>
                        <input matInput
                               formControlName="duration"
                               type="number"
                               min="1"
                               (change)="changeDateOrDuration(i)"
                               [required]="isFormFieldRequired(item.settingsType)"
                        >
                    </mat-form-field>
                </div>
                <div style="margin: -8px 0 8px 36px">
                    <mat-error *ngIf="formGroup?.controls[item.settingsType]?.errors
                                      && ((formGroup.controls[item.settingsType]?.errors['endDateIsSameOrBeforeStartDate']
                                          || formGroup.controls[item.settingsType]?.errors['minDateError'])
                                      || (formGroup.controls[item.settingsType]?.controls?.startDate?.errors['endDateIsSameOrBeforeStartDate']
                                          || formGroup.controls[item.settingsType]?.controls?.startDate?.errors['minDateError'])
                                      || (formGroup.controls[item.settingsType]?.controls?.endDate?.errors['endDateIsSameOrBeforeStartDate']
                                          || formGroup.controls[item.settingsType]?.controls?.endDate?.errors['minDateError']))"
                    >
                        End Date can't be the same or before Start Date.
                    </mat-error>
                </div>
            </div>
        </div>
    </ng-container>

    <div fxLayout="row" fxLayoutAlign="end center">
        <button *ngIf="isSystemSettings"
                mat-raised-button
                color="primary"
                class="mt-20"
                [disabled]="formGroup.invalid"
                (click)="onSaveDataRolloverSettings()"
        >
            Save
        </button>
    </div>
</div>

<div *ngIf="hasDataRolloverSettingsLoadError">
    <ngc-data-error></ngc-data-error>
</div>


<ng-template #dataRolloverSettingTitle let-item="item">
    <div class="mt-4">{{RolloverSettingsFriendlyNamesMap.get(item.settingsType)?.name}}</div>
    <div class="mat-caption secondary-text"
         *ngIf="!isPreviewDialog">{{RolloverSettingsFriendlyNamesMap.get(item.settingsType)?.tooltip}}</div>
</ng-template>
